export enum DPUploadType {
  DriverLicense,
  SingleFile,
  MultiFiles,
}
